export const addons = {
  success: true,
  data: {
    '141-0-2023-03-13-2023-03-15-1-0': {
      '61': {
        propertyId: '1',
        addonId: '61',
        productId: '151',
        isFixedPrice: 0,
        addonName: 'Addon #1',
        addonDescription: '',
        addonPhotos: [],
        maxQtyPerReservation: 0,
        chargeType: 'per_reservation',
        available: 'n/a',
        qty: 1,
        weekAvailability: [0, 1, 1, 0, 0, 0, 0],
        price: 10,
        priceWithInclusive: 10,
        totalPrice: 10,
        totalPriceWithInclusive: 10,
        totalTaxes: 0,
        totalFees: 0,
        grandTotal: 10,
        taxesGroupedById: [],
        feesGroupedById: [],
        taxesArray: [],
        feesArray: [],
        dailyRates: [
          {
            date: '2023-03-13',
            rate: 5,
          },
          {
            date: '2023-03-14',
            rate: 5,
          },
        ],
        priceSettings: 'show_as_separate',
        postingStrategy: 'booking_creation',
        currentStock: '0',
        doNotTrack: '1',
        stopSelling: null,
        productType: 'product',
      },
    },
  },
};
